module.exports = __webpack_public_path__ + "static/media/with-brand-name.b59722cb.svg";